import { ChatBubbleType } from 'src/types/generic';
import {
  IChatActionFeedback,
  IConversationHistoryResponseType,
} from 'src/types/serviceResponseTypes';

/**
 * Mapper to convert conversation history response to conversation atom state
 */

export default function withHistoryMapper(converations: IConversationHistoryResponseType) {
  return {
    id: Number(converations.conversation_id),
    messages: converations.chat_actions.map((previousMessage) => ({
      id: previousMessage.chat_action_id,
      content_type: previousMessage.multiple_choice_options
        ? 'multiple_choice'
        : ('single_input' as ChatBubbleType),
      content: previousMessage.message,
      explanation: previousMessage.explanation,
      nudge: previousMessage.nudge,
      from_user: previousMessage.role === 'user',
      is_ai_message: true,
      choices: previousMessage.multiple_choice_options
        ? previousMessage.multiple_choice_options.map((opt) => ({
            key: opt.option_id,
            text: opt.text_for_ui,
          }))
        : undefined,
      locked: true,
      feedback: mapFeedbackResponse(previousMessage.chat_action_id, previousMessage.feedback),
      ...(previousMessage?.student_response
        ? {
            is_correct: !!previousMessage.student_response?.includes(
              previousMessage?.correct_choice?.[0] ?? ''
            ),
            correct_choice: previousMessage?.correct_choice?.[0] ?? '',
            selected_choices: previousMessage.student_response,
          }
        : {}),
    })),
  };
}

export function mapFeedbackResponse(messageId: number, feedback: IChatActionFeedback) {
  return {
    messageId,
    disabled: true,
    isPositiveMarked: feedback?.is_positive ?? false,
    isNegativeMarked: feedback ? !feedback?.is_positive : false,
    selectedOption: feedback?.selected_option ?? '',
    feedbackText: feedback?.feedback_text ?? '',
  };
}
